import { module as m } from 'modujs';
import Swiper, { Autoplay } from 'swiper';
import 'swiper/css';
import {StoreSingleton} from "../../singletons/store";
import gsap from "gsap";

Swiper.use([Autoplay]);

export default class extends m {
    constructor(m) {
        super(m);
    }

    init() {
        this.swiper = new Swiper(this.$('swiper')[0], {
            slidesPerView: 1,
            spaceBetween: 24,
            loop: true,
            autoplay: {
                delay: 3000,
            },
            breakpoints: {
                1023: {
                    slidesPerView: 4,
                    spaceBetween: 24
                }
            }
        });
    }
}
